import React from 'react';
import { FieldControlProps } from '../FieldRenderer';

// display_style: single_line (default) | multiline
const TextInput: React.FC<FieldControlProps> = ({ field, value, onChange }) => {
  const stringValue = typeof value === 'string' ? value : '';

  if (field.display_style === 'multiline') {
    return (
      <textarea
        className="report-field-textarea"
        aria-label={field.field_label}
        value={stringValue}
        placeholder={field.placeholder}
        maxLength={field.validation?.max_length}
        onChange={(e) => onChange(e.target.value)}
        rows={4}
      />
    );
  }

  return (
    <input
      type="text"
      className="report-field-input"
      aria-label={field.field_label}
      value={stringValue}
      placeholder={field.placeholder}
      maxLength={field.validation?.max_length}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export default TextInput;
